import React, { ComponentProps } from 'react';
import { ImageCropper } from 'ionic-ui';
import DialogTitle from '../Dashboard/DialogTitle';

type Props = ComponentProps<typeof ImageCropper>;

export default function ImageCropperDialog(props: Props) {
  return (
    <div className="dialog-content space-y-6">
      <DialogTitle>Crop Image</DialogTitle>
      <ImageCropper {...props} />
    </div>
  );
}
